import { getAuthHeaders } from "@/shared/api/authHeaders";
import { keysToSnakeCase } from "@/shared/lib/case";
// This file is generated by generate-entities.ts. Please DO NOT edit this file directly.
import type { QueryOptions } from "@/shared/lib/tanstack-query";
import {
  type UseQueryResult,
  useQueries,
  useQuery,
} from "@tanstack/react-query";
import { FreightMatching } from "@x-mile/api-contract";
import type { GetNotificationParams } from "../model";

export const useGetNotification = (
  params: GetNotificationParams,
  options?: QueryOptions<typeof FreightMatching.useGetNotification>,
): UseQueryResult<FreightMatching.GetNotificationQueryResult, undefined> => {
  const authHeaders = getAuthHeaders();
  const result = useQuery({
    ...options,
    queryKey: ["getNotification", keysToSnakeCase(params)],
    queryFn: () =>
      FreightMatching.getNotification(
        params.id,
        // バックエンド（rails）ではキーがスネークケースになっているため、クエリパラメータをスネークケースに変換する

        {
          headers: authHeaders.isOk() ? authHeaders.value : {},
        },
      ),
  });
  return result as UseQueryResult<
    FreightMatching.GetNotificationQueryResult,
    undefined
  >;
};

export const useMultipleGetNotification = (
  paramsList: { [key: string | number]: GetNotificationParams },
  options?: QueryOptions<typeof FreightMatching.useGetNotification> & {
    sortFunc?: (a: GetNotificationParams, b: GetNotificationParams) => number;
  },
): {
  [key: string | number]: UseQueryResult<
    FreightMatching.GetNotificationQueryResult,
    undefined
  >;
} => {
  const authHeaders = getAuthHeaders();
  const keys = Object.keys(paramsList);
  const sortedKeys = options?.sortFunc
    ? keys.sort((a, b) =>
        options?.sortFunc ? options.sortFunc(paramsList[a], paramsList[b]) : 0,
      )
    : keys;
  const result = useQueries({
    queries: sortedKeys.map((key) => {
      const params = paramsList[key];
      return {
        ...options,
        queryKey: ["getNotification", keysToSnakeCase(params)],
        queryFn: () =>
          FreightMatching.getNotification(
            params.id,
            // バックエンド（rails）ではキーがスネークケースになっているため、クエリパラメータをスネークケースに変換する

            {
              headers: authHeaders.isOk() ? authHeaders.value : {},
            },
          ),
      };
    }),
  });
  const resultByKeys = Object.fromEntries(
    keys.map((key, i) => [key, result[i]]),
  );
  return resultByKeys as {
    [key: string | number]: UseQueryResult<
      FreightMatching.GetNotificationQueryResult,
      undefined
    >;
  };
};

// TODO: api-contract側でmockを生成しないことになったので、自前でmockを生成する
// export const useGetNotificationMock = (
//   params: GetNotificationParams,
//   options?: QueryOptions<typeof FreightMatching.useGetNotification>,
// ) => {
//   const [workerStarted, setWorkerStarted] = useState(false);
//   void (async () => {
//     if (!workerStarted) {
//       await FreightMatching.startMockServerWoker(
//         FreightMatching.getGetNotificationMockHandler(),
//       );
//       setWorkerStarted(true);
//     }
//   })();
//   return useGetNotification(params, {
//     enabled: workerStarted && options?.enabled,
//   });
// };

// export const useMultipleGetNotificationMock = (
//   paramsList: { [key: string | number]: GetNotificationParams },
//   options?: QueryOptions<typeof FreightMatching.useGetNotification>,
// ) => {
//   const [workerStarted, setWorkerStarted] = useState(false);
//   void (async () => {
//     if (!workerStarted) {
//       await FreightMatching.startMockServerWoker(
//         FreightMatching.getGetNotificationMockHandler(),
//       );
//       setWorkerStarted(true);
//     }
//   })();
//   return useMultipleGetNotification(paramsList, {
//     enabled: workerStarted && options?.enabled,
//   });
// };
